
    import {
        PlayCircleOutlined,
        PoweroffOutlined,
        DatabaseOutlined,
        TeamOutlined,
        FormOutlined,
        EyeOutlined,
        DeleteOutlined
    } from '@ant-design/icons-vue';

    import {
        defineComponent,
        onMounted,
        ref,
        createVNode,
        reactive
    } from 'vue';
    import {
        message,
        Modal
    } from 'ant-design-vue';
    import functionalAreas from "./components/functionalAreas.vue";
    import seeDetails from "./components/seeDetails.vue"
    import allocationReview from "./components/allocationReview.vue"
    import editActivity from "./components/editActivity.vue"
    import appraisementMechanism from "./components/appraisementMechanism.vue"
    import infotask from '@/service/infotask'

    export default defineComponent({
        components: {
            functionalAreas,
            PlayCircleOutlined,
            PoweroffOutlined,
            DatabaseOutlined,
            TeamOutlined,
            FormOutlined,
            EyeOutlined,
            seeDetails,
            allocationReview,
            editActivity,
            DeleteOutlined,
			appraisementMechanism
        },
        setup() {
            // 声明
            let columns = [{
                title: '序号',
                align: 'center',
                width: 60,
                dataIndex: 'serialNumber',
                key: 'serialNumber',
            },
                {
                    title: '活动名称',
                    dataIndex: 'taskName',
                    align: 'center',
                    key: 'taskName',
                }, {
                    title: '报名时间',
                    dataIndex: 'applyStartTime',
                    key: 'applyStartTime',
                    align: "center"
                }, {
                    title: '学科',
                    dataIndex: 'subjectScope',
                    key: 'subjectScope',
                    align: "center"
                }, {
                    title: '活动链接',
                    dataIndex: 'taskUrl',
                    key: 'taskUrl',
                    align: 'center',
                }, {
                    title: '创建时间',
                    dataIndex: 'createTime',
                    key: 'createTime',
                    align: "center"
                }, {
                    title: '报名人数',
                    dataIndex: 'enrollCount',
                    key: 'enrollCount',
                    align: "center"
                }, {
                    title: '状态',
                    dataIndex: 'status',
                    key: 'status',
                    align: "center"
                }, {
                    title: '操作',
                    key: 'action',
                    align: "center"
                }
            ];
            let tableData = [];
            const tableState = reactive({
                current: 1,
                total: 0,
                pageSize: 10
            })
            let tableLoading = ref(false);
            let conHeight = ref();
            const openEyePop = ref();
            const openPoplePop = ref();
            const openEditPop = ref();
            const openMechanismPop = ref();
            // 查询
            let searchValue = '', startDate = '', endDate = '';
            // 页面渲染时加载
            onMounted(() => {
                tableheight();
                queryTable();
            })
            // 获取当前屏幕高度 并设置 表格高度
            const tableheight = () => {
                let fullHeight = document.documentElement.clientHeight;
                conHeight.value = fullHeight - 112 - 200;
				
            }
            // 获取活动列表信息
            const queryTable = () => {
                tableLoading.value = true;
                const start = (tableState.current - 1) * tableState.pageSize;
                let startTime = startDate == '' ? '' : startDate + ' 00:00:01';
                let endTime = endDate == '' ? '' : endDate + ' 23:59:59';
                infotask.queryActivity(sessionStorage.getItem('schoolCode'), searchValue, start, tableState.pageSize, startTime, endTime).then(({data}) => {
                    tableLoading.value = false;
                    if (data.code !== 0) return;
                    data.data.map((item, index) => {
                        item.serialNumber = index + 1;
						item.createTime =item.createTime.slice(0,item.createTime.length-3)
                        return item;
                    })
					
                    tableData.value = data.data;
                    tableState.total = data.total;
                })
            }
            // 刷新页面
            const refresh = () => {
                queryTable();
            }
            // 搜索
            const search = (e) => {
                searchValue = e.searchValue;
                startDate = e.time;
                endDate = e.time;
                queryTable();
            }
            // 选择一页展示多少条数据
            const onShowSizeChange = (current, pageSize) => {
                tableState.pageSize = pageSize;
                tableState.current = current;
                queryTable();
            }
            // 切换分页
            const changePagination = (page, pageSize) => {
                tableState.pageSize = pageSize;
                tableState.current = page;
                queryTable();
            }
            // 手动开始
            const onStart = (e) => {
                Modal.confirm({
                    title: '确认要手动开始?',
                    content: createVNode('div', {
                        style: 'color:red;',
                    }, ''),
                    cancelText: '取消',
                    okText: '确认',
                    onOk() {
                        infotask.changeStatus(e.id, '1').then(({data}) => {
                            message.success(data.msg);
                            queryTable();
                        })
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                    class: 'test',
                });
            }
            // 手动结束
            const onEnd = (e) => {
                Modal.confirm({
                    title: '确认要手动结束么?',
                    content: createVNode('div', {
                        style: 'color:red;',
                    }, ''),
                    cancelText: '取消',
                    okText: '确认',
                    onOk() {
                        infotask.changeStatus(e.id, '6').then(({data}) => {
                            message.success(data.msg);
                            queryTable();
                        })
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                    class: 'test',
                });

            }
			
			// 评审机制
			const appPop = (e) =>{
				openMechanismPop.value.open(e);
			}
			
            // 添加人员
            const addPop = (e) => {
                openPoplePop.value.open(e);
            }
            // 编辑活动
            const edit = (e) => {
                openEditPop.value.open(e);
            }
            // 查看详情
            const eyeDetails = (e) => {
                openEyePop.value.open(e);
            }
            // 删除活动
            const delDetails = (e) => {
                Modal.confirm({
                    title: '确认要删除?',
                    content: createVNode('div', {
                        style: 'color:red;',
                    }, ''),
                    cancelText: '取消',
                    okText: '确认',
                    onOk() {
                        infotask.delActivity(e.id).then(({data}) => {
                            if (data.code == '0') {
                                queryTable();
                                message.success('删除成功');
                            } else {
                                message.error(data.msg);
                            }
                        })
                    },
                    onCancel() {
                        console.log('Cancel');
                    },
                    class: 'test',
                });
            }
            return {
                refresh,
                search,
                columns,
                tableData,
                tableState,
                conHeight,
                tableheight,
                onShowSizeChange,
                changePagination,
                onStart,
                onEnd,
                openEyePop,
                eyeDetails,
                openPoplePop,
                openEditPop,
                addPop,
				appPop,
                edit,
                tableLoading,
                delDetails,
				openMechanismPop,
				queryTable
            };
        },

    });
